import { AHTeamIconCircleRelay, DialogButton, useCircleSize } from "arkh";
import { graphql, useFragment } from "react-relay";
import { DialogButtonTeamsDetail_team$key } from "./__generated__/DialogButtonTeamsDetail_team.graphql";
import { View } from "react-native";
import { FormattedMessage } from "react-intl";
import { DialogButtonTeams_teams$key } from "./__generated__/DialogButtonTeams_teams.graphql";

const MAX_SHOWING_INDICATORS = 3;

export function TeamNamesLabel(props: {
  names: string[];
  maxShowingIndicators?: number;
}) {
  if (props.names.length === 0) {
    return (
      <FormattedMessage
        defaultMessage="All Teams"
        description="All Teams Label"
      />
    );
  }
  return <>{formatTeamNames(props.names, props.maxShowingIndicators)}</>;
}

export function formatTeamNames(
  names: string[],
  maxShowingIndicators: number = MAX_SHOWING_INDICATORS
) {
  if (names.length === 1) {
    return names[0];
  }
  if (names.length === 2) {
    return names.join(" & ");
  }
  const formattedNames = names.slice(-maxShowingIndicators).join(", ");
  const remaining =
    names.length > maxShowingIndicators
      ? `  +${names.length - maxShowingIndicators}`
      : "";

  return `${formattedNames} ${remaining}`;
}

export function DialogButtonTeams(props: {
  teams: DialogButtonTeams_teams$key;
  onPress?: () => void;
  isLocked?: boolean;
}) {
  const teams = useFragment(
    graphql`
      fragment DialogButtonTeams_teams on Team @relay(plural: true) {
        id
        name
        ...DialogButtonTeamsDetail_team
      }
    `,
    props.teams
  );

  return (
    <DialogButton
      mode={props.isLocked ? "locked-active" : "active"}
      onPress={props.onPress}
      indicatorComponent={
        teams.length > 0 ? <DialogButtonTeamsDetail teams={teams} /> : undefined
      }
      indicatorIcon={teams.length === 0 ? "team-home" : undefined}
    >
      <TeamNamesLabel names={teams.map((e) => e.name)} />
    </DialogButton>
  );
}

function DialogButtonTeamsDetail(props: {
  teams: DialogButtonTeamsDetail_team$key;
}) {
  const teams = useFragment(
    graphql`
      fragment DialogButtonTeamsDetail_team on Team @relay(plural: true) {
        id
        ...AHTeamIconCircle
      }
    `,
    props.teams
  );
  const size = useCircleSize("smallMedium");

  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      {teams.slice(-MAX_SHOWING_INDICATORS).map((e, index) => (
        <View key={e.id} style={{ marginLeft: index === 0 ? 0 : -size / 4 }}>
          <AHTeamIconCircleRelay team={e} size="small" />
        </View>
      ))}
    </View>
  );
}
